const mapIdentifier = require('./identifier');
const mapInventoryProperties = require('./inventoryProperties');
const mapProperties = require('./properties');
const mapVariant = require('./variant');
const mapVariantProperties = require('./variantProperties');

module.exports = {
  mapIdentifier,
  mapInventoryProperties,
  mapProperties,
  mapVariant,
  mapVariantProperties
};
